import React from 'react'
import { Stack, Title, Grid } from 'components'
import { NumberInput } from '@mantine/core'
import { DateInput } from '@mantine/dates'
import { useTranslation } from 'react-i18next'
import { ProjectPlanningData } from '../../../types'

interface ProjectPlanningSectionProps {
  planning: ProjectPlanningData
  onChange: (field: keyof ProjectPlanningData, value: any) => void
}

export const ProjectPlanningSection: React.FC<ProjectPlanningSectionProps> = ({
  planning,
  onChange
}) => {
  const { t } = useTranslation()

  return (
    <Stack spacing="md">
      <Title order={3}>{t('arc_project_time_planning')}</Title>

      <Grid gutter="md">
        <Grid.Col span={12} md={6}>
          <NumberInput
            size="lg"
            withAsterisk
            label={t('arc_weeks')}
            value={planning.weeks}
            onChange={(value) => onChange('weeks', value || 1)}
            min={1}
            max={52}
            required
          />
        </Grid.Col>

        <Grid.Col span={12} md={6}>
          <NumberInput
            size="lg"
            withAsterisk
            label={t('arc_days_per_week')}
            value={planning.daysPerWeek}
            onChange={(value) => onChange('daysPerWeek', value || 1)}
            min={1}
            max={7}
            required
          />
        </Grid.Col>

        <Grid.Col span={12} md={6}>
          <NumberInput
            size="lg"
            withAsterisk
            label={t('arc_lesson_duration')}
            value={planning.lessonDurationMinutes}
            onChange={(value) => onChange('lessonDurationMinutes', value || 15)}
            min={15}
            max={180}
            step={15}
            required
          />
        </Grid.Col>

        <Grid.Col span={12} md={6}>
          <DateInput
            size="lg"
            withAsterisk
            label={t('arc_start_date')}
            value={planning.startDate}
            onChange={(value) => onChange('startDate', value)}
            required
            clearable={false}
          />
        </Grid.Col>
      </Grid>
    </Stack>
  )
}